import { render } from "./TestAppSigninView.vue?vue&type=template&id=611c7bea&scoped=true"
import script from "./TestAppSigninView.vue?vue&type=script&lang=js"
export * from "./TestAppSigninView.vue?vue&type=script&lang=js"

import "./TestAppSigninView.vue?vue&type=style&index=0&id=611c7bea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611c7bea"]])

export default __exports__